import type { BackendMenuItem } from './menu-builder';

/**
 * 检查当前路径是否在用户有权限的菜单列表中
 *
 * @param pathname - 当前浏览器路径（如 /saas-platform/cms/sites）
 * @param menus - 用户有权限的菜单列表（扁平结构，来自 initialState.menus）
 * @param isRoot - 是否为超级管理员
 * @returns 是否允许访问
 */
export function isUrlPermitted(
  pathname: string,
  menus: BackendMenuItem[],
  isRoot: boolean,
): boolean {
  if (isRoot) return true;
  if (!menus || menus.length === 0) return false;

  const urls = menus.map((m) => m.url).filter(Boolean);

  const exactMatch = urls.some((url) => url === pathname);
  if (exactMatch) return true;

  const dynamicMatch = urls.some((url) => {
    if (!url.includes(':')) return false;
    const pattern = url.replace(/:[^/]+/g, '[^/]+');
    const regex = new RegExp(`^${pattern}$`);
    return regex.test(pathname);
  });

  return dynamicMatch;
}
